<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
import 'bootstrap/dist/css/bootstrap.css';
import 'bootstrap-vue/dist/bootstrap-vue.css';

import '@/assets/scss/style.scss';
import '@/assets/scss/icons/material-design/scss/materialdesignicons.scss';

export default {
  name: 'App',

  mounted() {
    window.dataLayer.push({
      event: 'LeroyMerlin_Pageview',
      pageType: 'Landing',
      pagePath: window.location.href,
      userId: null,
      userAuth: '0',
      platform: 'aem',
    });
  },
};
</script>
